<template>
    <div class="our-product__container">
        <div id="scene2" data-relative-input="true">
            <div data-depth="0.2">
                <img
                    src="/images/landing-page/floating-bottom-left-1.svg"
                    alt="vector floating"
                    class="position-absolute floating-bottom-left-1"
                />
            </div>
            <div data-depth="0.4">
                <img
                    src="/images/landing-page/floating-bottom-center.svg"
                    alt="vector floating"
                    class="position-absolute floating-bottom-center"
                />
            </div>
            <div data-depth="0.8">
                <img
                    src="/images/landing-page/floating-bottom-right-1.svg"
                    alt="vector floating"
                    class="position-absolute floating-bottom-right-1"
                />
            </div>
        </div>

        <Swiper ref="mySwiper" class="swiper" :options="swiperOptions">
            <!-- Slide 1 -->
            <SwiperSlide>
                <div
                    class="our-product__item our-product__item--theta-index d-flex justify-content-center align-items-center"
                >
                    <div class="d-flex flex-column">
                        <div>
                            <span class="text-uppercase">
                                Our Flagship Product
                            </span>
                        </div>
                        <div>
                            <h4
                                class="our-product__item-title gradient-text gradient-text--animated"
                            >
                                USDC Stronghold
                            </h4>
                            <p>
                                Start generating income by swapping for a
                                yield-bearing token backed by an index of puts
                                on market majors including BTC, ETH, BNB, and
                                more
                            </p>
                        </div>
                        <div class="d-flex our-product__item-benefits">
                            <span class="gradient-text gradient-text--animated"
                                >Sustainable Yield</span
                            >
                            <span class="gradient-text gradient-text--animated"
                                >Diversifed Risk</span
                            >
                            <span class="gradient-text gradient-text--animated"
                                >No Vault Fees</span
                            >
                        </div>
                    </div>
                    <div
                        class="our-product__item-card-container justify-content-center"
                    >
                        <div
                            class="d-flex flex-column p-3 our-product__item-card"
                        >
                            <div
                                class="d-flex justify-content-between align-items-center our-product__token"
                            >
                                <div
                                    class="d-flex align-items-center justify-content-center"
                                >
                                    <div>
                                        <img
                                            src="/images/landing-page/our-product-usdc.svg"
                                            alt="usdc"
                                        />
                                    </div>
                                    <span>USDC</span>
                                </div>
                                <div class="our-product__token--type">
                                    <span>Stronghold</span>
                                </div>
                            </div>
                            <hr />
                            <div
                                class="d-flex justify-content-between our-product__token-information"
                            >
                                <div class="d-flex flex-column">
                                    <span>APY</span>
                                    <span>50.6%</span>
                                </div>
                                <div class="d-flex flex-column">
                                    <span class="text-right">TVL</span>
                                    <span>88 M</span>
                                </div>
                            </div>
                            <hr />
                            <div
                                class="d-flex align-items-center justify-content-center"
                            >
                                <a href="https://stronghold.thetanuts.finance/">
                                    <div class="our-product__token-btn">
                                        Swap
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="our-product__caption">
                            <span
                                >*Product card for illustrative purposes
                                only</span
                            >
                        </div>
                        <div class="our-product__more-assets d-none">
                            <span class="text-uppercase">
                                More Assets
                                <img
                                    src="/images/landing-page/icon-arrow-right.svg"
                                    alt="arrow right"
                                    class="ms-3"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </SwiperSlide>

            <!-- Slide 2 -->
            <!-- <SwiperSlide>
                <div
                    class="our-product__item our-product__item--theta-index d-flex justify-content-center align-items-center"
                >
                    <div class="d-flex flex-column">
                        <div>
                            <span class="text-uppercase">
                                Our Flagship Product
                            </span>
                        </div>
                        <div>
                            <h4
                                class="our-product__item-title gradient-text gradient-text--animated"
                            >
                                UST Stronghold
                            </h4>
                            <p>
                                Start generating income by swapping for a yield
                                bearing token backed by an index of LUNA put
                                selling strategies
                            </p>
                        </div>
                        <div class="d-flex our-product__item-benefits">
                            <span class="gradient-text gradient-text--animated"
                                >Sustainable Yield</span
                            >
                            <span class="gradient-text gradient-text--animated"
                                >Risk-Adjusted</span
                            >
                            <span class="gradient-text gradient-text--animated"
                                >No Vault Fee Structures</span
                            >
                        </div>
                    </div>
                    <div
                        class="our-product__item-card-container justify-content-center"
                    >
                        <div
                            class="d-flex flex-column p-3 our-product__item-card"
                        >
                            <div
                                class="d-flex justify-content-between align-items-center our-product__token"
                            >
                                <div
                                    class="d-flex align-items-center justify-content-center"
                                >
                                    <div>
                                        <img
                                            src="/images/landing-page/our-product-ust.png"
                                            alt="ust"
                                        />
                                    </div>
                                    <span>UST</span>
                                </div>
                                <div class="our-product__token--type">
                                    <span>Stronghold</span>
                                </div>
                            </div>
                            <hr />
                            <div
                                class="d-flex justify-content-between our-product__token-information"
                            >
                                <div class="d-flex flex-column">
                                    <span>Index APY</span>
                                    <span>115.5%</span>
                                </div>
                                <div class="d-flex flex-column">
                                    <span class="text-right">TVL</span>
                                    <span>-</span>
                                </div>
                            </div>
                            <hr />
                            <div
                                class="d-flex align-items-center justify-content-center"
                            >
                                <a>
                                    <div
                                        class="our-product__token-btn"
                                        style="cursor: initial;"
                                    >
                                        Coming Soon
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="our-product__caption">
                            <span
                                >*Product card for illustrative purposes
                                only</span
                            >
                        </div>
                        <div class="our-product__more-assets d-none">
                            <span class="text-uppercase">
                                More Assets
                                <img
                                    src="/images/landing-page/icon-arrow-right.svg"
                                    alt="arrow right"
                                    class="ms-3"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </SwiperSlide> -->

            <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import Parallax from "parallax-js";

export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: "1",
                spaceBetween: 30,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
                // Some Swiper option/callback...
            }
        };
    },
    mounted() {
        var scene = document.getElementById("scene2");
        var parallaxInstance = new Parallax(scene);
    }
};
</script>

<style lang="scss" scoped>
#scene2 {
    // height: 55vh;
    height: 595px;
    width: 100vw;
    max-width: 100%;
    position: absolute;

    > div {
        width: 100%;
        height: 100%;
    }
}

.our-product__container {
    height: 725px;
    padding-bottom: 30px;
    position: relative;
}

.floating-bottom-left-1 {
    width: 75px;
    left: 0;
    bottom: 10%;
    animation: floatingBottom1 2s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 115px;
    }
}
.floating-bottom-center {
    width: 62px;
    left: 50%;
    top: 0;
    animation: floatingBottom2 10s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 92px;
    }
}
.floating-bottom-right-1 {
    width: 69px;
    right: 0;
    bottom: 40%;
    animation: floatingBottom3 15s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 129px;
    }
}

.our-product__item {
    padding: 0 130px;
    height: 100%;
    flex-direction: column;

    @media only screen and (min-width: 768px) {
        flex-direction: row;
    }

    > div {
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    &.our-product__item--blue {
        .our-product__item-title {
            color: #0ddbe8;
        }
        .our-product__item-benefits {
            color: #0ddbe8;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #0ddbe8;
            box-shadow: 0px 0px 11.3529px rgba(13, 219, 232, 0.7);
        }
        .our-product__token-btn {
            color: #0ddbe8;
        }
    }

    &.our-product__item--yellow {
        .our-product__item-title {
            color: #fbff3c;
        }
        .our-product__item-benefits {
            color: #fbff3c;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #fbff3c;
            box-shadow: 0px 0px 11.3529px rgba(251, 255, 60, 0.7);
        }
        .our-product__token-btn {
            color: #fbff3c;
        }
    }

    &.our-product__item--purple {
        .our-product__item-title {
            color: #cc3cff;
        }
        .our-product__item-benefits {
            color: #cc3cff;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #cc3cff;
            box-shadow: 0px 0px 11.3529px rgba(110, 226, 159, 0.4);
        }
        .our-product__token-btn {
            color: #cc3cff;
        }
    }

    &.our-product__item--put {
        .our-product__item-title {
            color: #e67c00;
        }
        .our-product__item-benefits {
            color: #e67c00;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #e67c00;
            box-shadow: 0px 0px 11.3529px rgba(220, 152, 21, 0.4);
        }
        .our-product__token-btn {
            color: #e67c00;
        }
    }

    &.our-product__item--call {
        .our-product__item-title {
            color: #33a9ff;
        }
        .our-product__item-benefits {
            color: #33a9ff;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #33a9ff;
            box-shadow: 0px 0px 11.3529px rgba(110, 226, 159, 0.4);
        }
        .our-product__token-btn {
            color: #33a9ff;
        }
    }

    &.our-product__item--theta-index {
        .our-product__item-title {
            color: transparent;
        }
        .our-product__item-benefits {
            color: transparent;
        }
        .our-product__item-card {
            background: linear-gradient(
                180deg,
                #2c2c2c 0%,
                rgba(16, 16, 16, 0.8) 100%
            );
            border: 2.27059px solid #81e429;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
        }
        .our-product__token-btn {
            // color: #81e429;
            background: linear-gradient(
                180deg,
                #2699da 27.78%,
                #63b22d 122.22%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
        }
    }

    > div {
        &:first-child {
            width: 285px;

            @media only screen and (min-width: 375px) {
                width: 335px;
            }
            @media only screen and (min-width: 425px) {
                width: 365px;
            }

            @media only screen and (min-width: 1440px) {
                // width: 556px;
                width: 595px;
            }

            div {
                &:nth-child(1) {
                    span {
                        font-family: Inter;

                        font-size: 12px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 23px;
                        letter-spacing: 0px;

                        @media only screen and (min-width: 1440px) {
                            font-size: 18px;
                            line-height: 36px;
                        }
                    }
                }

                &:nth-child(2) {
                    border-top: 2px dashed rgba(255, 255, 255, 0.6);
                    border-bottom: 2px dashed rgba(255, 255, 255, 0.6);
                    margin: 30px 0;
                    padding: 30px 0;

                    h4 {
                        font-family: Sofia Sans;
                        font-size: 23px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 23px;
                        letter-spacing: 0px;

                        @media only screen and (min-width: 1440px) {
                            font-size: 36px;
                            line-height: 36px;
                        }
                    }
                    p {
                        font-family: Inter;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 23px;
                        letter-spacing: 0px;

                        @media only screen and (min-width: 1440px) {
                            font-size: 24px;
                            line-height: 36px;
                        }
                    }
                }

                &.our-product__item-benefits {
                    gap: 20px;

                    @media only screen and (min-width: 1440px) {
                        gap: 30px;
                    }

                    span {
                        font-family: Inter;
                        font-size: 13px;
                        font-weight: 600;
                        font-style: italic;
                        line-height: 23px;
                        letter-spacing: 0px;

                        @media only screen and (min-width: 1440px) {
                            font-size: 20px;
                            line-height: 36px;
                        }
                    }
                }
            }
        }

        &.our-product__item-card-container {
            width: 100%;
            justify-content: center;

            @media only screen and (min-width: 1024px) {
                justify-content: flex-end;
            }

            @media only screen and (min-width: 768px) {
                width: 250px;
                margin-left: 100px;
            }

            @media only screen and (min-width: 1024px) {
                margin-left: 150px;
            }

            @media only screen and (min-width: 1440px) {
                width: 386px;
            }

            .our-product__item-card {
                transition: all ease 0.3s;

                .our-product__token-btn {
                    font-family: Barlow;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 34px;
                    letter-spacing: 0em;
                    text-align: center;
                    transition: all ease 0.3s;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.7;
                    }
                }

                &:hover {
                    transition: all ease 0.3s;
                }
            }

            .our-product__caption {
                margin-top: 0 !important;
                margin-left: 20px;

                span {
                    font-family: Inter;
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: 0px;
                    text-align: left;
                    display: block;
                    margin-top: 5px;

                    @media only screen and (min-width: 1440px) {
                        font-size: 12px;
                    }
                }
            }

            .our-product__more-assets {
                text-align: right;

                @media only screen and (min-width: 768px) {
                    text-align: left;
                }
            }

            hr {
                border: 1px solid;
                width: 100%;
                opacity: 0.5;
                margin-top: 20px;
                margin-bottom: 20px;
            }

            > div {
                &:nth-child(1) {
                    border-radius: 12px;

                    .our-product__token {
                        img {
                            width: 32px;
                        }
                        span {
                            font-family: Roboto;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 21px;
                            letter-spacing: 0em;

                            margin-left: 10px;

                            @media only screen and (min-width: 1440px) {
                                font-size: 27px;
                                line-height: 32px;
                            }
                        }
                    }
                    .our-product__token--type {
                        font-family: Barlow;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 25px;
                        letter-spacing: 0em;

                        @media only screen and (min-width: 1440px) {
                            font-size: 32px;
                            line-height: 38px;
                        }
                    }

                    .our-product__token-information {
                        div {
                            span {
                                &:first-child {
                                    font-family: Roboto;
                                    font-size: 10px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 12px;
                                    letter-spacing: 0em;

                                    @media only screen and (min-width: 1440px) {
                                        font-size: 16px;
                                        line-height: 19px;
                                    }
                                }
                            }

                            &:first-child {
                                span {
                                    &:nth-child(2) {
                                        font-family: Barlow;
                                        font-size: 20px;
                                        font-style: normal;
                                        font-weight: 600;
                                        line-height: 25px;
                                        letter-spacing: 0em;

                                        @media only screen and (min-width: 1440px) {
                                            font-size: 32px;
                                            line-height: 38px;
                                        }
                                    }
                                }
                            }
                            &:nth-child(2) {
                                span {
                                    &:nth-child(2) {
                                        font-family: Roboto;
                                        font-size: 20px;
                                        font-style: normal;
                                        font-weight: 600;
                                        line-height: 24px;
                                        letter-spacing: 0em;
                                        text-align: right;

                                        @media only screen and (min-width: 1440px) {
                                            font-size: 32px;
                                            line-height: 37px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                &:nth-child(2) {
                    font-family: Sofia Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 23px;
                    letter-spacing: 0px;

                    margin-top: 25px;

                    @media only screen and (min-width: 1440px) {
                        font-size: 22px;
                        line-height: 36px;
                        margin-top: 30px;
                    }

                    img {
                        width: 13px;
                        margin-left: 10px;

                        @media only screen and (min-width: 1440px) {
                            width: 21px;
                            margin-left: 15px;
                        }
                    }
                }
            }
        }
    }
}

// swiper
.swiper {
    height: 100%;
    width: 100%;

    &::v-deep {
        &.swiper-container-horizontal > .swiper-pagination-bullets {
            bottom: -5px;
        }
    }

    ::v-deep {
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        // temporary hide
        .swiper-pagination {
            // display: none;
        }

        .swiper-pagination-bullet {
            background: #9e9e9e;
            opacity: 1;
            margin: 0 6px;
            width: 10px;
            height: 10px;

            &.swiper-pagination-bullet-active {
                background: #1af9d1;
            }
        }
    }
}

@keyframes rotated {
    to {
        transform: rotate(360deg);
    }
}

@keyframes floatingBottom1 {
    0% {
        left: 0%;
        bottom: 13%;
    }
    100% {
        left: 0;
        bottom: 10%;
    }
}
@keyframes floatingBottom2 {
    0% {
        left: 52%;
        top: 9%;
    }
    20% {
        left: 48%;
        top: 8%;
    }
    40% {
        left: 51%;
        top: 10%;
    }
    60% {
        left: 50%;
        top: 7%;
    }
    80% {
        left: 47%;
        top: 10%;
    }
    100% {
        left: 50%;
        top: 7%;
    }
}
@keyframes floatingBottom3 {
    0% {
        right: 0;
        bottom: 45%;
    }
    20% {
        right: 5%;
        bottom: 43%;
    }
    40% {
        right: 3%;
        bottom: 38%;
    }
    60% {
        right: 1%;
        bottom: 37%;
    }
    80% {
        right: 2%;
        bottom: 41%;
    }
    100% {
        right: 0;
        bottom: 40%;
    }
}

.gradient-text {
    background-image: linear-gradient(
        95.12deg,
        #1cc8c1 0%,
        #05feb1 0.01%,
        #d9ef46 28.64%,
        #ff843f 49.48%,
        #a2f9e4 73.96%,
        #05feb1 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
    color: transparent;
    text-transform: none;

    background-size: 300%;
    background-position: -100%;

    &.gradient-text--animated {
        animation: animatedText 5s infinite alternate-reverse;
    }
}

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
